import React from "react";
import {
  AutoExpansionPanelGroup,
  AutoExpansionPanel,
  ExpansionPanelHeader,
  ExpansionPanelHeaderDescription,
  ExpansionPanelContent,
  ExpansionPanelContentBody
} from "@cdk-uip/react-expansion-panel";

import InvoiceConfigurationDataTable from "./InvoiceConfigurationDataTable";

const InvoiceConfiguration = ({ config, handleChange }) => (
  <AutoExpansionPanelGroup>
    <AutoExpansionPanel>
      <ExpansionPanelHeader>
        <ExpansionPanelHeaderDescription>
          Expand this section to reveal configuration options for your invoice.
        </ExpansionPanelHeaderDescription>
      </ExpansionPanelHeader>
      <ExpansionPanelContent>
        <ExpansionPanelContentBody>
          <InvoiceConfigurationDataTable
            config={config}
            handleChange={handleChange}
          />
        </ExpansionPanelContentBody>
      </ExpansionPanelContent>
    </AutoExpansionPanel>
  </AutoExpansionPanelGroup>
);

export default InvoiceConfiguration;
